export const USER_DETAIL = "USER_DETAIL_SUCCESS"